export default {
  title: '會員裝修',
  previewTitle: '會員中心',
  pageSetting: '頁面設置',
  pageTitle: '頁面標題',
  pageTitlePlaceholder: '請輸入頁面標題',
  defaultPageTitle: '個人中心',
  modules: '功能模組',
  template: '頁面模板',
  templateType: '模板類型',
  bgColor: '背景顏色',
  moduleList: '模組列表',
  moduleConfig: '模組配置',
  editText: '編輯文字',
  editTextTitle: '編輯文字',
  templateGoldBlack: '黑金模板',
  templateGoldWhite: '白金模板',
  useDefaultIcon: '使用默認圖標',
  addNav: '新增導航',
  navNamePlaceholder: '請輸入導航名稱',
  navLinkPlaceholder: '請輸入跳轉連結',
  memberCenterLink: '會員中心地址',
  copyLinkTitle: '複製連結',
  copyAddress: '複製地址',
  copy: '複製',
  copySuccess: '複製成功',
  scanToPreview: '掃一掃立即預覽',
  linkTipH5: '此連結適用於H5環境',
  syncConfig: '同步配置',
  syncConfigTitle: '同步配置',
  syncConfigDesc: '將當前語言（{lang}）的配置同步到以下語言：',
  syncConfigSuccess: '同步成功',
  moduleNames: {
    MemberInfo: '會員信息',
    NavBar: '導航欄',
    PointsRedPacket: '積分與紅包',
    TabBar: '底部導航',
  },
  labelName: {
    levelName: '鑽石會員',
    progressLabel: '距離升級',
    progressUnit: '點成長值',
    benefitsText: '會員權益',
    pointsTitle: '我的積分',
    pointsRule: '兌換規則',
    pointsExchange: '積分兌換',
    redpacketTitle: '我的紅包',
    redpacketRule: '兌換規則',
    redpacketExchange: '紅包兌換',
  },
  formLabel: {
    memberLevel: '會員等級',
    memberBenefits: '會員權益',
    pointsModule: '積分模組',
    points: '積分',
    rule: '規則',
    pointsExchange: '積分兌換',
    redpacketModule: '紅包模組',
    redpacket: '紅包',
    redpacketExchange: '紅包兌換',
  },
};